import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { InternalCandidacyComment } from "@/types";

/**
 * This hook is used to remove an internal candidacy comment in the internal
 * candidacy comments query without refetching the entire query.
 */
export const useSetRemoveInternalCandidacyCommentInInternalCandidacyComments =
  () => {
    const currentCompanyId = useCurrentCompanyId();
    const currentJobId = useCurrentJobId();
    const queryClient = useQueryClient();

    return ({
      candidacyId,
      internalCandidacyCommentToRemove,
    }: {
      candidacyId: string;
      internalCandidacyCommentToRemove: InternalCandidacyComment;
    }) => {
      queryClient.setQueryData(
        [
          "internal-candidacy-comments",
          currentCompanyId,
          currentJobId,
          candidacyId,
        ],
        (cachedData: InternalCandidacyComment[]) => {
          return cachedData.filter(
            (internalCandidacyComment) =>
              internalCandidacyComment.id !==
              internalCandidacyCommentToRemove.id,
          );
        },
      );
    };
  };
